module.exports = __webpack_public_path__ + "img/t2.3c4c461f.png";